import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCardModule } from '@angular/material/card';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule}  from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatRadioModule} from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AngularDraggableModule } from 'angular2-draggable';
import {MatDialogModule} from '@angular/material/dialog';
import { HttpClientModule } from '@angular/common/http';

import { HeatmatrixComponent } from '../instant-analysis/heatmatrix/heatmatrix.component';

import { SearchFieldComponent } from '../history-analysis/search-field/search-field.component';
import { RainCalendarComponent } from './rain-calendar/rain-calendar.component';
import { IntervalRainCalendarComponent } from './components/interval-rain-calendar/interval-rain-calendar.component';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';
import { SaveAnalysisDialogComponent } from '../mainmenu/save-analysis-dialog/save-analysis-dialog.component';

// Os tipos websocket e polling foram definidos para a conexão do socket.io com
// redis, como explicado em https://medium.com/@codeandcam/clustering-an-express-socket-io-server-with-pm2-789d11865f95
const config: SocketIoConfig = { 
  url: environment.socketIOUrl, options: {
    transports: [ 'websocket', 'polling' ]
  } 
};


const shared = [
  CommonModule,
  MatToolbarModule,
  MatButtonModule,
  MatIconModule,
  MatSidenavModule,
  MatDatepickerModule,
  MatFormFieldModule,
  ReactiveFormsModule,
  FormsModule,
  MatNativeDateModule,
  MatDividerModule,
  MatListModule,
  MatSelectModule,
  MatInputModule,
  MatExpansionModule,
  MatMenuModule,
  ScrollingModule,
  MatTableModule,
  DragDropModule,
  MatButtonToggleModule,
  MatCardModule,
  MatTabsModule,
  MatSnackBarModule,
  MatTooltipModule,
  MatPaginatorModule,
  AngularDraggableModule,
  MatChipsModule,
  MatAutocompleteModule,
  MatRadioModule,
  MatDialogModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatSlideToggleModule,
]

/**
 * Exporta módulos do Angular / Material, e componentes que podem ser utilizados
 * nos outros módulos.
 */
@NgModule({
  declarations: [
    SearchFieldComponent,
    RainCalendarComponent,
    IntervalRainCalendarComponent,
    SaveAnalysisDialogComponent,
  ],
  imports: [
    ...shared,
    HttpClientModule,
    SocketIoModule.forRoot(config),
  ],
  exports: [
    ...shared,
    SearchFieldComponent,
    RainCalendarComponent,
    IntervalRainCalendarComponent,
    SaveAnalysisDialogComponent,
  ],
})
export class SharedModule { }
